import { HttpErrorResponse } from "@angular/common/http";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { ToastService } from "@app/shared/ui";
import { Observable, OperatorFunction, of, throwError } from "rxjs";
import { catchError, delay, filter, mergeMap, retryWhen, switchMap, take } from "rxjs/operators";

/** function to receive error message from error.
 *  @deprecated Use import from `core-kit`
 */
export function httpErrorMessageHandler(err: HttpErrorResponse): string {
  if (err.status == 403) return "Forbidden";
  return err.error.Message ?? err.error;
}
/** Pipe for Clearline API requests. Alerts API error message.
 * @param errorMessageFn - function to receive error message from error.
 * @deprecated Use import from `core-kit`
 */
export function alertApiError<T>(
  toastSvc: ToastService,
  errorMessageFn: (x: HttpErrorResponse) => string = httpErrorMessageHandler
): OperatorFunction<T, T> {
  return (source: Observable<T>) => {
    return source.pipe(
      catchError((err: HttpErrorResponse) => {
        const errorMsg = errorMessageFn(err);
        toastSvc.danger(errorMsg);
        return throwError(err);
      })
    );
  };
}

/** Pipe. Navigates to path on error.
 * @param path - Navigate to path items. Default - parent path.
 * @deprecated Use import from `core-kit`
 */
export function navigateOnError<T>(router: Router, route: ActivatedRoute, paths: any[] = [".."]): OperatorFunction<T, T> {
  return (source: Observable<T>) => {
    return source.pipe(
      catchError((err) => {
        router.navigate(paths, { relativeTo: route });
        return throwError(err);
      })
    );
  };
}

/** Pipe for Clearline API requests. Alerts API error message.
 * @deprecated Use import from `core-kit`
 */
export function retryOnError<T>(attemptsCount: number, delayMs: number): OperatorFunction<T, T> {
  return (source: Observable<T>) => {
    return source.pipe(
      retryWhen((errors) =>
        errors.pipe(
          mergeMap((err, attemptInd) => {
            if (attemptInd < attemptsCount - 1) return of(err);
            return throwError(err);
          }),
          delay(delayMs)
        )
      )
    );
  };
}

export function retryOnNavigation<T>(router: Router): OperatorFunction<T, T> {
  return (source: Observable<T>) =>
    source.pipe(
      retryWhen((errors) =>
        errors.pipe(
          switchMap(() =>
            router.events.pipe(
              filter((event) => event instanceof NavigationEnd),
              take(1)
            )
          )
        )
      )
    );
}
